import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';

import Grid from '@mui/material/Grid';

import DateTimePicker from '../../../../components/styled/datetimepicker';
import Moment from 'moment';
import { GetISODateFromQuick } from '../../../../libraries/helpers';
import PopupMenu from '../../../../components/popupmenu';

const useStyles = makeStyles(theme => ({
    root: {
    },
    datePicker: {
        maxWidth: 140,
    },
}));

const quickFilters = [
    { key: 'week', title: 'Last Week' },
    { key: 'day', title: 'Last Day' },
    { key: 'hour', title: 'Last Hour' },
];

const DateRange = (props) => {
    const classes = useStyles();
    const theme = useTheme();

    const [range, setRange] = useState({});

    const handleOnQuickFilter = quick => {
        const start = GetISODateFromQuick(quick.key);
        props.onChange({ start, end: undefined, quick: quick.key });
    };

    const handleStartChange = start => {
        start = start ? start.utc().toISOString() : undefined;
        props.onChange({ start, end: props.schedule.end, quick: '' });
    };

    const handleEndChange = end => {
        end = end ? end.utc().toISOString() : undefined;
        props.onChange({ end, start: props.schedule.start, quick: '' });
    };

    const quickTitle = () => {
        if (props.schedule && props.schedule.quick) {
            const qf = quickFilters.find(q => q.key === props.schedule.quick);
            return qf ? qf.title : 'Date Range';
        }
        return 'Date Range';
    };

    // initial hook
    useEffect(() => {
        setRange({
            start: props.schedule.start ? Moment(props.schedule.start) : undefined,
            end: props.schedule.end && props.schedule.end !== '0001-01-01T00:00:00Z'
                ? Moment(props.schedule.end) : undefined
        });
    }, [props.schedule]);

    return (
        <Grid container justifyContent="flex-start" alignItems="center">
            <Grid item style={{ paddingTop: 15 }}>
                {/* quick filters */}
                <PopupMenu
                    items={quickFilters}
                    itemkey="key"
                    onSelect={handleOnQuickFilter}
                    selection={props.schedule.quick}
                    title={quickTitle()}/>
            </Grid>
            <Grid item className={classes.datePicker}>
                <DateTimePicker
                    ampm={false}
                    label="Start"
                    value={range.start}
                    onChange={handleStartChange}
                    inputFormat={theme.date.short}
                    disableMaskedInput={true}
                    maxDate={range.end}
                    showTodayButton={true}/>
            </Grid>
            <Grid item className={classes.datePicker}>
                <DateTimePicker
                    clearable={true}
                    variant="dialog"
                    ampm={false}
                    label="End"
                    value={range.end}
                    onChange={handleEndChange}
                    inputFormat={theme.date.short}
                    disableMaskedInput={true}
                    minDate={range.start}
                    showTodayButton={true}/>
            </Grid>
        </Grid>
    );
};
DateRange.propTypes = {
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

const GetDateDesc = (quick, start, end, format) => {
    const q = quick === 'hour' ? 'Last Hour: '
        : quick === 'day' ? 'Last Day: '
            : quick === 'week' ? 'Last Week: '
                : '';
    start = quick ? Moment(GetISODateFromQuick(quick))
        : Moment(start).isValid() ? Moment(start).format(format) : '';
    end = quick ? 'Now' : Moment(end).isValid() ? Moment(end).format(format) : 'Now';

    return `${q}${start} - ${end}`;
};

export {
    DateRange as default,
    GetDateDesc
};
